import { Component, Vue, Ref } from 'vue-property-decorator';
import throttle from '../../utils/helpers/throttle';

@Component({})
export default class Gallery extends Vue {
  @Ref('gallery') galleryEl!: HTMLElement;

  public currentIndex = 0;
  public slideNumber = 0;

  public get firstSlide(): boolean {
    return this.currentIndex === 0;
  }

  public get lastSlide(): boolean {
    return this.currentIndex === this.slideNumber - 1;
  }

  public goToPrev() {
    if (!this.firstSlide) {
      this.scrollToIndex(this.currentIndex - 1);
    }
  }

  public goToNext() {
    if (!this.lastSlide) {
      this.scrollToIndex(this.currentIndex + 1);
    }
  }

  public scrollToIndex(index: number) {
    this.galleryEl.scrollTo({
      top: 0,
      left: (this.galleryEl.scrollWidth / this.slideNumber) * index,
      behavior: 'smooth'
    });
  }

  public get onScroll() {
    return throttle(() => {
      this.currentIndex = Math.round(this.galleryEl.scrollLeft / (this.galleryEl.scrollWidth / this.slideNumber));
    });
  }
}
